import { type FC } from "react";
import { type FilterFormPropsBase } from "../types/props";
import { type CampaignFiltersEnum } from "features/Library/SimulatedPhishing/Campaigns/types/models";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getCampaignsFilters } from "./campaignsFilters";

export interface CampaignsFilterFormProps extends FilterFormPropsBase<CampaignFiltersEnum> {}

const CampaignsFilterForm: FC<CampaignsFilterFormProps> = ({
  filterOptions,
  filter,
  onValidationChange,
  updateFilter,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getCampaignsFilters()}
    onValidationChange={onValidationChange}
  />
);

export default CampaignsFilterForm;
